import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dt-mainCard__content-block" }
const _hoisted_2 = {
  key: 0,
  class: "dt-mainCard__content-block-title"
}
const _hoisted_3 = {
  key: 0,
  class: "dt-mainCard__content-gallery margin-bottom-min"
}
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = { class: "swiper-slide" }
const _hoisted_6 = ["href", "data-fancybox"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-scrollbar" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.element.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.element.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.items, (gallery, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (gallery.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["block-swiperGallery swiper", this.generateSwiperClass(key)])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gallery.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("a", {
                        href: item.url,
                        class: "",
                        "data-fancybox": this.dataFancybox(key)
                      }, [
                        _createElementVNode("img", {
                          src: item.url
                        }, null, 8 /* PROPS */, _hoisted_7)
                      ], 8 /* PROPS */, _hoisted_6)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _hoisted_8
              ], 2 /* CLASS */)
            ]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}